<template>
    <div class="notification" :class="typeClass">
        <button v-if="hideButton" type="button" class="delete" @click="hide" />

        <slot />
    </div>
</template>

<script>
    export default {
        data() {
            return {
            };
        },

        props: {
            type: {
                type: String,
                required: false,
            },

            hideButton: {
                type: Boolean,
                required: false,
                default: false,
            },
        },

        computed: {
            typeClass() {
                const { type } = this;

                return type ? `is-${type}` : '';
            },
        },

        methods: {
            hide() {
                this.$emit('hide', false);
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/global/components/Notification.vue